import React from 'react';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import BulletinContent from './BulletinContent';

interface SafeBulletinContentProps {
  content: string;
  size: 'small' | 'medium' | 'large';
  position?: 'center' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  hasImage?: boolean;
}

const SafeBulletinContent = (props: SafeBulletinContentProps) => {
  return (
    <ErrorBoundary
      fallback={
        <div className="absolute inset-0 flex items-center justify-center p-6">
          <p className="text-white/70 text-sm text-center">
            Content temporarily unavailable
          </p>
        </div>
      }
    >
      <BulletinContent {...props} />
    </ErrorBoundary>
  );
};

export default SafeBulletinContent;